import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(routes)/(auth)/forgot-password/components/ForgotPasswordForm.tsx");
